(function(){
"use strict";
var box=document.querySelector(".drev");
if(!box)return;
var pista=box.querySelector(".pista");
var prev=box.querySelector(".prev");
var next=box.querySelector(".next");
var punti=box.querySelector(".punti");
var giostra=box.querySelector(".giostra");
if(!pista)return;
var rec=pista.querySelectorAll(".rec");
if(!rec.length)return;

var i=0,perVista=3,timer;
function quante(){var w=innerWidth;perVista=w<=640?1:(w<=1024?2:3)}
function max(){return Math.max(0,rec.length-perVista)}
function disegnaPunti(){
 punti.innerHTML="";
 for(var n=0;n<=max();n++){
  var d=document.createElement("button");
  d.className="punto"+(n===i?" on":"");
  (function(n){d.addEventListener("click",function(){vai(n)})})(n);
  punti.appendChild(d);
 }
}
function aggiorna(){
 var w=rec[0].offsetWidth;
 pista.style.transform="translateX(-"+(i*(w+20))+"px)";
 var p=punti.querySelectorAll(".punto");
 for(var n=0;n<p.length;n++)p[n].classList.toggle("on",n===i);
}
function vai(n){i=Math.max(0,Math.min(n,max()));aggiorna();riparti()}
function avanti(){i=i>=max()?0:i+1;aggiorna()}
function indietro(){i=i<=0?max():i-1;aggiorna()}
function parti(){timer=setInterval(avanti,6000)}
function riparti(){clearInterval(timer);parti()}

prev.addEventListener("click",function(){indietro();riparti()});
next.addEventListener("click",function(){avanti();riparti()});
giostra.addEventListener("mouseenter",function(){clearInterval(timer)});
giostra.addEventListener("mouseleave",parti);

var x0=0;
giostra.addEventListener("touchstart",function(e){x0=e.changedTouches[0].screenX},{passive:true});
giostra.addEventListener("touchend",function(e){
 var d=x0-e.changedTouches[0].screenX;
 if(Math.abs(d)>50){d>0?avanti():indietro();riparti()}
},{passive:true});

addEventListener("resize",function(){
 quante();disegnaPunti();
 if(i>max())i=max();
 aggiorna();
});

quante();disegnaPunti();aggiorna();parti();
})();
